import { render, staticRenderFns } from "./expiration-time.vue?vue&type=template&id=28561b6e&scoped=true&lang=pug&"
import script from "./expiration-time.vue?vue&type=script&lang=ts&"
export * from "./expiration-time.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28561b6e",
  null
  
)

export default component.exports